import SchedulingLimits from 'components/SchedulingLimits'
import { useAuth } from 'context/AuthContext'
import { useTenantContext } from 'context/TenantContext'
import { useFetch } from 'utils/fetch-helper'
import { FetchMethods } from 'utils/types'

function SchedulingRules({ 
    onPrevSelect,
}: { 
    onPrevSelect(): void
}) {
    const { StaffModal } = useAuth()
    const { tenant } = useTenantContext()
    const { attributes } = StaffModal

    const restriction_template = {
        bookMaxDaysInAdvance: 0,
        bookMinBeforeStartTime: 0,
        canCancel: false,
        canResched: false,
        cancelMinBeforeStartTime: 0,
        lookupId: attributes?.id as string,
        reschedMinBeforeStartTime: 0,
        staffId: attributes?.id as string,
        tenantId: tenant?.id as string,
        type: 'STAFF'
    }

    const { data: data_restriction } = useFetch(
        `/v1/scheduling-restrictions/by-staff-id?staffId=${attributes?.id}`,
        FetchMethods.GET,
        !!attributes?.id
    )

    return (
        <SchedulingLimits
            restriction_template={restriction_template}
            local_restriction={data_restriction}
            cancel_label="previous"
            onSave={() => {
                StaffModal.close()
            }}
            show_scheduling_limits
        />
    )
}

export default SchedulingRules
